
// Simple plant component using primitive shapes
import React, {useMemo} from "react";

export function Plant({ position, scale = 1, type = 'default' }) {
    const colors = {
        default: { stem: '#518c21', leaf: '#66a832' },
        carrot: { stem: '#2d6a4f', leaf: '#40916c' },
        tomato: { stem: '#386641', leaf: '#588157' }
    };

    const style = colors[type] || colors.default;

    // Memoize the plant structure so it doesn't change on every render
    const plantStructure = useMemo(() => {
        // Use a fixed base stem height instead of random
        const stemHeight = 1.25; // Or any other base height you prefer (e.g., 1.0)

        // Create the leaf positions (this part remains the same)
        const leaves = [...Array(3)].map((_, i) => {
            const angle = (i / 3) * Math.PI * 2;
            const x = Math.sin(angle) * 0.3;
            const z = Math.cos(angle) * 0.3;
            const y = 0.3 + i * 0.3;
            return { position: [x, y, z], rotation: [0, angle, Math.PI / 4] };
        });

        return { stemHeight, leaves };
        // Keep the dependency array empty, as the base structure is now fixed
    }, []);

    return (
        <group position={position} scale={[scale, scale, scale]}>
            {/* Stem */}
            <mesh position={[0, plantStructure.stemHeight/2, 0]} castShadow>
                <cylinderGeometry args={[0.05, 0.05, plantStructure.stemHeight, 8]} />
                <meshStandardMaterial color={style.stem} />
            </mesh>

            {/* Leaves */}
            {plantStructure.leaves.map((leaf, i) => (
                <mesh key={i} position={leaf.position} rotation={leaf.rotation} castShadow>
                    <sphereGeometry args={[0.2, 8, 8, 0, Math.PI * 2, 0, Math.PI / 2]} />
                    <meshStandardMaterial color={style.leaf} side={2} />
                </mesh>
            ))}
        </group>
    );
}